import { useEffect, useState } from "react";
import { Crown, Calendar, Plus } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/contexts/CartContext";
import { toast } from "sonner";

const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];

export default function DailyMenu() {
  const today = new Date().toLocaleDateString("en-US", { weekday: "long" });
  const [day, setDay] = useState(today);
  const [menu, setMenu] = useState(null);
  const { addItem } = useCart();

  useEffect(() => {
    api.get("/daily-menus", { params: { day }}).then(({ data }) => setMenu(data[0] || null)).catch(() => setMenu(null));
  }, [day]);

  const add = (it) => {
    addItem({ item_type: "restaurant", item_id: it.id, name: it.name, unit_price: it.price, image: it.image });
    toast.success(`${it.name} added`);
  };

  return (
    <div className="chow-theme bg-[#050505] min-h-screen text-[#FAF9F6]" data-testid="daily-menu-page">
      <section className="border-b border-[#D4AF37]/30 py-14 text-center">
        <Calendar className="w-10 h-10 text-[#D4AF37] mx-auto mb-2" strokeWidth={1.5} />
        <span className="font-accent text-xs text-[#D4AF37]">DAILY MENU</span>
        <h1 className="font-heading text-5xl mt-2">Today's <span className="italic text-[#D4AF37]">Royal Feast</span></h1>
        <p className="text-[#FAF9F6]/60 mt-2">{day}</p>
      </section>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8">
        <div className="flex gap-2 overflow-x-auto no-scrollbar mb-8">
          {DAYS.map((d) => (
            <button
              key={d}
              data-testid={`day-${d.toLowerCase()}`}
              onClick={() => setDay(d)}
              className={`px-5 py-2 text-xs font-accent uppercase tracking-wider whitespace-nowrap ${
                d === day ? "bg-[#D4AF37] text-[#050505]" : "text-[#D4AF37] border border-[#D4AF37]/40 hover:bg-[#D4AF37]/10"
              }`}
            >{d}</button>
          ))}
        </div>

        {menu?.promo_banner && (
          <div className="mb-8 text-center font-heading text-2xl italic text-[#D4AF37]">"{menu.promo_banner}"</div>
        )}

        {!menu ? (
          <p className="text-center text-[#FAF9F6]/50 py-16">No menu published for {day}.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {(menu.items || []).map((it) => (
              <article key={it.id} className="chow-card overflow-hidden">
                {it.image && <div className="h-40 bg-cover bg-center" style={{backgroundImage: `url(${it.image})`}} />}
                <div className="p-5">
                  <h3 className="font-heading text-2xl text-[#D4AF37]">{it.name}</h3>
                  <p className="text-sm text-[#FAF9F6]/60 mb-3 line-clamp-2">{it.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="font-heading text-lg">${it.price.toFixed(2)}</span>
                    <button
                      data-testid={`daily-add-${it.id}`}
                      onClick={() => add(it)}
                      className="w-9 h-9 rounded-full bg-[#D4AF37] text-[#050505] flex items-center justify-center hover:bg-[#E8D08D]"
                    ><Plus className="w-4 h-4" /></button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
